export const homeObjOne = {
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    headline: 'Ideate. Collaborate. Lead.',
    description:
      'We are currently working in virtual mode. Feel free to join us on the server!',
    buttonLabel: 'Join us on Discord',
    imgStart: '',
    img: 'images/test4.png',
    alt: 'Event Image'
  };
  
  export const homeObjTwo = {
    lightBg: true,
    lightText: false,
    lightTextDesc: false,
    headline: 'Events with international exposure.',
    description:
      "Developers and open source enthusiasts from across the globe address our members during our events.",
    buttonLabel: 'Get Involved',
    imgStart: 'start',
    img: 'images/test3.png',
    alt: 'Event Image'
  };
  
  export const homeObjThree = {
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    topLine: 'Join Us!',
    headline: 'Let\'s go on a technical adventure.',
    description:
      'We cover a wide variety of activities like tech summits, hackathons, tech talks and a lot more!',
     buttonLabel: 'Join Us Now!',
    imgStart: '',
    img: 'images/test4.png',
    alt: 'Event Image'
  };